"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservedKeyType = exports.getReservedPrefix = void 0;
const constants_iso_1 = require("@wranggle/constants-iso");
Object.defineProperty(exports, "ReservedKeyType", { enumerable: true, get: function () { return constants_iso_1.ReservedKeyType; } });
const exceptions_1 = require("../exceptions");
const allReservedKeyTypes = new Set(Object.values(constants_iso_1.ReservedKeyType));
function getReservedPrefix(reservedKeyType) {
    if (!allReservedKeyTypes.has(reservedKeyType)) {
        throw new exceptions_1.PlusPlusPlus('UnknownReservedKeyType', { reservedKeyType });
    }
    return `${constants_iso_1.WranggleReservedPrefix}${reservedKeyType}`;
}
exports.getReservedPrefix = getReservedPrefix;
//# sourceMappingURL=reserved-key-util.js.map